/**
 * The truck and its dashed trail used to be one baked PNG. They are split so
 * the truck can drive the trail: the image is now the vehicle alone, cropped
 * from (86,52) of the original 835x299 artwork, and the trail is the curve
 * that PNG drew, retraced as a path in the same coordinate space.
 */
const TRAIL_PATH =
  "M283,110 C294.5,107.9 330.5,100.6 352,97.2 C373.5,93.8 392,91.1 412,89.9 C432,88.7 451.5,88.6 472,89.9 C492.5,91.1 514.5,93.9 535,97.6 C555.5,101.3 575,106 595,111.9 C615,117.9 635,124.7 655,133.4 C675,142 695,152.2 715,163.7 C735,175.2 755.2,188.8 775,202.5 C794.8,216.2 824.2,238.7 834,246";

export interface LoginRouteArtworkProps {
  /**
   * Mirrored, as in Figma, so the trail sweeps in from the right and the
   * truck comes to rest next to the form column. The form column sits on
   * the opposite side of the page in LTR, so the trail is left unmirrored
   * there to keep the truck ending next to the form instead of driving off
   * toward the outer edge.
   */
  readonly mirrored?: boolean;
}

export function LoginRouteArtwork({ mirrored = true }: LoginRouteArtworkProps) {
  return (
    <svg
      viewBox="0 0 835 299"
      fill="none"
      aria-hidden="true"
      data-node-id="2676:155633"
      className={
        "absolute start-[19.31%] top-[1.23%] w-[66.12%] overflow-visible" +
        (mirrored ? " -scale-x-100" : "")
      }
    >
      <defs>
        {/* Clears the trail ahead of the truck, so the dashes are laid down behind it. */}
        <mask id="login-trail-reveal">
          <path
            d={TRAIL_PATH}
            pathLength={1}
            stroke="white"
            strokeWidth={18}
            strokeLinecap="round"
            className="login-trail"
          />
        </mask>
      </defs>

      <path
        d={TRAIL_PATH}
        stroke="white"
        strokeWidth={5.5}
        strokeLinecap="round"
        strokeDasharray="12 6"
        mask="url(#login-trail-reveal)"
        className="login-trail-dashes"
      />

      <image
        href="/brand/login-truck.png"
        x={86}
        y={52}
        width={198}
        height={135}
        className="login-truck"
      />
    </svg>
  );
}
